<template>
  <div class="row full-height background-spacing-color valign-wrapper">
    <div class="row center-align z-depth-3">

      <!-- Left column -->
      <div class="col box-size no-padding">
        <InformationColumn
        :informationType="contentType"></InformationColumn>
      </div>

      <!-- Right column -->
      <div class="col box-size no-padding white-background">
        <router-view/>
      </div>

    </div>
  </div>
</template>

<script>
// Left side
import router from '../../router'
import InformationColumn from '../login/_InformationColumn.vue'
import AuthService from '../../services/AuthService'

// Right side
export default {
  components: {
    InformationColumn: InformationColumn
  },
  data () {
    return {
      preventLogin: false,
      versionNumber: process.env.VERSION,
      isAuthenticated: false,
      contentType: null
    }
  },
  created () {
    this.$eventHub.$on('loadingpossdata', this.toggleChildLoadingData)
  },
  methods: {
    toggleChildLoadingData (value) {
      this.childIsLoadingData = value
    }
  },
  mounted () {
    if (AuthService.isAuthenticated()) {
      this.contentType = 1
      router.push('/login/loaddata')
    } else {
      router.push('login/loginscreen')
    }
  },
  beforeRouteUpdate (to, from, next) {
    if (!this.childIsLoadingData) {
      next()
    } else {
      next(false)
    }
    if (to.path === '/login') {
      next(false)
    }
  }
}
</script>

<style>

 /* CUSTOM INPUT FIELD COLORS */
 /* label color */
   .input-field label {
      color: rgba(0, 0, 0, 0.38);
   }
   /* label focus color */
   .input-field input[type=email]:focus + label {
     color: rgba(0, 0, 0, 0.38);
   }
    .input-field input[type=text]:focus + label {
     color: rgba(0, 0, 0, 0.38);
   }
    .input-field input[type=password]:focus + label {
     color: rgba(0, 0, 0, 0.38);
   }

   /* label underline focus color */
   .input-field input[type=email]:focus {
     border-bottom: 1px solid #56CCF2;
     box-shadow: 0 1px 0 0 #56CCF2;
   }
      /* label underline focus color */
   .input-field input[type=text]:focus {
     border-bottom: 1px solid #56CCF2;
     box-shadow: 0 1px 0 0 #56CCF2;
   }
    .input-field input[type=password]:focus {
     border-bottom: 1px solid #56CCF2;
     box-shadow: 0 1px 0 0 #56CCF2;
   }

   /* valid color */
   .input-field input[type=email].valid {
     border-bottom: 1px solid #56CCF2;
     box-shadow: 0 1px 0 0 #56CCF2;
   }
      .input-field input[type=text].valid {
     border-bottom: 1px solid #56CCF2;
     box-shadow: 0 1px 0 0 #56CCF2;
   }
   .input-field input[type=password].valid {
     border-bottom: 1px solid #56CCF2;
     box-shadow: 0 1px 0 0 #56CCF2;
   }

   /* icon prefix focus color */
   .input-field .prefix.active {
     color: #000;
   }

  .cursor-hand {
    cursor: pointer;
  }

  .app-body-height {
    height:90%;
  }

  .app-footer-height {
    height: 10%;
  }

  .app-footer-margins {
    padding-left: 53px;
    padding-right: 49px;
  }

  .full-height-percent {
    height: 100%;
  }

  .grey-color {
    color: rgba(0, 0, 0, 0.38);
  }

  .blue-color {
    color: #56CCF2;
  }

  h5 {
    font-size: 24px;
    font-family:Roboto;
    font-weight: 200;
    font-style: normal;
    line-height: normal;
  }

  p {
    font-family:Roboto;
    font-weight: 100;
  }

  .progression-cloud {
    background-color: white;
    height: 2px;
    margin: 0px;
  }

  .white-background {
    background-color: white;
  }

  .blue-color-background {
    background-color: #56CCF2 !important;
  }

  .no-border {
    border: none;
    border-bottom: none;
  }

  .no-margin {
    margin: 0px;
  }

  .no-padding-left {
    padding-left: 0px !important;
  }

  .no-padding-right {
    padding-right: 0px;
  }

  *:focus {
    outline: 0;
  }

  .signin-button {
    background-color: #56CCF2;
    min-width: 94px;
  }

  .box-size {
    width: 403px;
    height: 592px;
  }

  .background-spacing-color {
    background-color: #F2F2F2;
  }
</style>



// WEBPACK FOOTER //
// src/pages/login/Login.vue